import { ItManagementTerminateEmployeesDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface QueryParameters {
  employeeIds: [number]
}

export const useTerminateEmployees = () => {
  const [terminateEmployees, { loading }] = useMutation(ItManagementTerminateEmployeesDocument, {
    extractorFn: (data) =>
      data.itManagementMutations.terminateEmployeesItmanagementEmployeeSoftwareMembership,
  })

  return {
    delete(params: QueryParameters) {
      return terminateEmployees({
        variables: { employeeIds: params.employeeIds },
      })
    },
    loading,
  }
}
